<template>
    <div v-if="document">
        <div v-if="!editors.length">
            <div class="element-label">{{('First time: ' + label || 'Permissions')}}</div>

            No write permissions
            <v-btn @click="initialisePermissions" depressed rounded>Create</v-btn>
        </div>
        <template v-if="canWrite">
            <div class="element-label">{{label || 'Permissions'}}</div>
            <div v-for="uid in editors" :key="uid">
                {{uid}}
            </div>
        </template>
    </div>
</template>

<script>

import Security from '../data/Security'

export default {

    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        document: Object,
        label: String,
    },

    computed: {
        myId() {
            return Security.getMyId() 
        },

        editors() {
            if(!this.document || !this.document.permissions || !this.document.permissions.editors)
                return []
            else
                return this.document.permissions.editors
        },

        canWrite() {
            return Security.canWrite(this.document)
        },
        
        publicOrPrivate() {
            return (this.value && this.value.public ? 'Public' : 'Private')
        }
    },

    methods: {
        initialisePermissions() {
            this.$set(this.document, 'permissions', {editors: [this.myId]})
            this.$emit('change')
        }
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// Permissions.vue?05b3dde3